module.exports = "/images/zipForm.png?4a1d427abd9c2b428e9d9e2b8cc119ff";